<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data(){
    return{
      description:'',
      keywords:'',
      title:'',
    }
  },
  // updated() {
  //   window.scroll(0, 0);
  // },
  // mounted() {
  //   var href = window.location.href;
  //   if (href.indexOf("http://www.ftkj.net/") != -1) {
  //     if (
  //       href.indexOf("move") != -1 ||
  //       href.indexOf("index.html") != -1
  //     ) {
  //       this.$router.push("/");
  //     }
  //   } else if (href == "http://m.ftkj.net/") {
  //     this.$router.push("/move/");
  //   }
  // },
  async mounted() {
    var href = window.location.href;
    await this.getKeyswords()
    // var href = 'http://m.ftkj.net/';
    if(href.indexOf("http://www.ftkj.net/admin") != -1){
      this.$router.push("/admin")
    }
    else if (href.indexOf("http://www.ftkj.net/") != -1) {
      let flag = this.IsPC()
      console.log(flag)
      if(flag==true){
        if(href.indexOf("move") != -1 || href.indexOf("index.html") != -1){
          this.$router.push('/')
        }
      }else{
        this.$router.push('/move/')
      }
    } else if (href == "http://m.ftkj.net/") {
      this.$router.push("/move/");
    }
  },
  metaInfo () {
      return {
        title: this.title,
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.keywords },
          { vmid: 'description', name: 'description', content: this.description }
        ]
      }
    },
  methods: {
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    async getKeyswords(){
      // console.log(this.$store.state.title)
      const res = await this.$axios.post("/api/keyswords")
      res.data = JSON.parse(res.data)
      // console.log(res)
      if (res.data.code === 0) {
        // console.log(res.data.data)
        res.data.data.map(item=>{
          // console.log(item.keywords)
          if(item.keywords === 'keywords'){
            this.keywords = item.content
          }
          if(item.keywords === 'description'){
            this.description = item.content
          }
          if(item.keywords === 'title'){
            this.title = item.content
          }
        })
        this.$store.commit("mutitle",this.title)
        // console.log(this.$store.state.title)
      }else{
        this.keywords = '石家庄网站建设,石家庄微信营销,石家庄网页设计,石家庄软件开发'
        this.description = '石家庄飞天科技,专业的品牌视觉设计传播机构,致力于网站建设(网页设计.优化.推广).微信营销(微网站制作.活动策划).软件开发.品牌设计等,详询:0311-85048504...'
      }
    }
  }
};
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue